export const HTTP_METHODS = ['get', 'post', 'put', 'patch', 'delete', 'head', 'options'];

export const GENERIC_API_TEMPLATE = `{
  "version": 3,
  "endpoint": "",
  "method": "post",
  "headers": {
    "content-type": "application/json"
  },
  "bodyPath": "$.body"
}`;
